import { gql } from '@apollo/client'

export const GET_PUBLIC_CAMPAIGN_SHARES_QUERY = gql`
  query getPublicCampaignSharesDetails($campaignId: ID!) {
    getCampaign(
      campaignId: $campaignId
      params: {
        fields: [
          "share_settings.digital_assets"
          "assets.digital_asset.eligible_share_types"
        ]
      }
    ) {
      id
      name

      start_date
      end_date

      description

      logo_public_id

      share_settings_count_per_share_type {
        channel
        count
      }

      brand {
        id
        name
        logo_url
      }

      share_settings {
        id
        name
        share_type
        description
        created_at
        updated_at
        share_data {
          share_data {
            description
          }
        }
        digital_assets {
          id
          file {
            id
            public_id
          }
        }
      }
      assets {
        id
        enabled

        created_at
        updated_at

        digital_asset {
          id
          name
          file_url
          file {
            id
            public_id
            bytes
            width
            height
            resource_type
          }

          eligible_share_types {
            tiktok {
              link
              photo
              video
            }
          }
        }
      }
    }
  }
`
